export const environment = {
  apiURL: 'https://api.visio.dev.br',
  permissionsApiUrl: 'https://api.visio.dev.br',
  token: 'tokenVisio',
  local: false
}
